(function (global) {
  function fetchCartFxEstimate(lines, displayCurrency, done) {
    if (!displayCurrency || !lines || lines.length === 0) {
      if (done) {
        done(null);
      }
      return;
    }

    $.ajax({
      url: '/api/products/fxCartEstimate',
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        display_currency: displayCurrency,
        lines: lines
      }),
      success: function (res) {
        if (done) {
          done(res && res.success ? res : null);
        }
      },
      error: function () {
        if (done) {
          done(null);
        }
      }
    });
  }

  function cartShouldShowFxEstimate(cart, displayCurrency) {
    if (!displayCurrency) {
      return false;
    }

    var dc = String(displayCurrency).trim().toUpperCase();
    var currencies = {};

    cart.forEach(function (item) {
      var c = (item.currency && String(item.currency).trim()) || 'USD';
      currencies[c.toUpperCase()] = true;
    });

    var keys = Object.keys(currencies);

    if (keys.length === 1 && keys[0] === dc) {
      return false;
    }

    return true;
  }

  global.fetchCartFxEstimate = fetchCartFxEstimate;
  global.cartShouldShowFxEstimate = cartShouldShowFxEstimate;
})(typeof window !== 'undefined' ? window : this);